import { throwIfNotOk } from "@/lib/api-error";

export class FaqApiError extends Error {
  constructor(
    message: string,
    readonly code?: string,
  ) {
    super(message);
    this.name = "FaqApiError";
  }
}

export async function faqApi<T = unknown>(path: string, init?: RequestInit, errorMessage = "Greška"): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: init?.body
      ? { "content-type": "application/json", ...init.headers }
      : init?.headers,
  });
  if (res.status === 409) {
    const body = (await res.json().catch(() => ({}))) as { error?: string; code?: string };
    throw new FaqApiError(body.error || errorMessage, body.code ?? body.error);
  }
  await throwIfNotOk(res, errorMessage);
  return (res.status === 204 ? null : await res.json()) as T;
}
